import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Home, Search } from 'lucide-react';

export default function NotFoundPage() {
  return (
    <div style={{ backgroundColor: 'var(--mi-bg)' }}>
      <Header />
      <div className="mi-container py-24 text-center">
        <p className="font-display text-8xl" style={{ color: 'var(--mi-accent)' }}>404</p>
        <h1 className="font-display text-3xl mt-4 mb-3" style={{ color: 'var(--mi-fg)' }}>Pagina non trovata</h1>
        <p className="text-base mb-8" style={{ color: 'var(--mi-text)' }}>La pagina che cerchi non esiste o è stata spostata.</p>
        <div className="flex items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-5 h-10 rounded-xl text-sm font-medium"
            style={{ backgroundColor: 'var(--mi-fg)', color: 'var(--mi-bg)' }}
          >
            <Home size={14} /> Torna alla home
          </Link>
          <Link
            to="/attivita"
            className="inline-flex items-center gap-2 px-5 h-10 rounded-xl text-sm font-medium border"
            style={{ borderColor: 'var(--mi-border)', color: 'var(--mi-fg)', backgroundColor: '#fff' }}
          >
            <Search size={14} /> Sfoglia attività
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
}
